<template>
  <div 
    class="user-list-header m-vertical-5 is-grid"
    :fill="false"
    grid
  >
    <div class="is-col-1"></div>

    <div class="is-col-2">
      <p>
        <small>
          Email
        </small>
      </p> 
    </div>

    <div class="is-col-3">
      <p>
        <small>
          Nom
        </small>
      </p> 
    </div>

    <div class="is-col-4">
      <p>
        <small>
          Rôles
        </small>
      </p> 
    </div>

    <div class="is-col-2">
      <p>
        <small>
          Inscrit le
        </small>
      </p> 
    </div>
  </div>
</template>

<style lang="scss">
  .user-list-header {
    padding: 0.45rem 1rem 0.45rem 1rem;
  }
</style>